import { Contract } from '~/layers/forms/models'

export const useLead = ({
  contract,
  insurable,
}: {
  contract: Ref<Contract>
  insurable: Ref<Insurable>
}) => {
  const currentLeadId = ref<number | null>(null)
  const _contract = contract
  const _insurable = insurable

  const buildBody = (
    stage: SiteApiSchema<'OportunidadEtapa'> = 'NoDefinido'
  ): SiteApiSchema<'OportunidadCreationModel'> | SiteApiSchema<'OportunidadEditionModel'> => {
    if (currentLeadId.value) {
      return Contract.map.toOportunidadEditionModel({
        model: _contract.value,
        insurable: _insurable.value,
        stage: stage,
        id: currentLeadId.value,
      })
    }
    return Contract.map.toOportunidadCreationModel({
      model: _contract.value,
      insurable: _insurable.value,
      stage: stage,
    })
  }

  const submit = async (stage: SiteApiSchema<'OportunidadEtapa'> = 'NoDefinido') => {
    const body = buildBody(stage)

    try {
      const result = await $fetch<SiteApiSchema<'OportunidadModel'>>('/api/lead', {
        method: currentLeadId.value ? 'PUT' : 'POST',
        body,
      })
      currentLeadId.value = result.id ?? null
      return true
    } catch {
      return false
    }
  }

  return {
    submit,
  }
}
